import React, { useEffect } from "react";
import "./Documents.css";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
const Documents = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    console.log(location);
    location.pathname === "/admin-dashboard/documents" &&
      navigate("/admin-dashboard/documents/assign-leads");
  });
  return (
    <div className="admindash__documents_wrap">
      <div className="admindash__documents_sidebar">
        <div className="admindash__documents_sbheading">Documents</div>
        <div className="admindash__documents_sbitems">
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/assign-leads"
          >
            <div className="admindash__documents_sbitemlft">Assign Leads</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/all"
          >
            <div className="admindash__documents_sbitemlft">All</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/messages"
          >
            <div className="admindash__documents_sbitemlft">Messages</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/new-file"
          >
            <div className="admindash__documents_sbitemlft">New File</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <hr />
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/docs-pending"
          >
            <div className="admindash__documents_sbitemlft">Docs Pending</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/call-back"
          >
            <div className="admindash__documents_sbitemlft">Call Back</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/call-india"
          >
            <div className="admindash__documents_sbitemlft">Call India</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/docs-reviewed"
          >
            <div className="admindash__documents_sbitemlft">Docs. Reviewed</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/add-docs-pending"
          >
            <div className="admindash__documents_sbitemlft">
              Add Docs. Pending
            </div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/add-docs-reviewed"
          >
            <div className="admindash__documents_sbitemlft">
              Add Docs. Reviewed
            </div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/payment-trying"
          >
            <div className="admindash__documents_sbitemlft">Payment Trying</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/payment-recieved"
          >
            <div className="admindash__documents_sbitemlft">
              Payment Recieved
            </div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/voice-mail"
          >
            <div className="admindash__documents_sbitemlft">Voice Mail</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/not-interested"
          >
            <div className="admindash__documents_sbitemlft">Not Interested</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <hr />
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/extension"
          >
            <div className="admindash__documents_sbitemlft">Extension</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/amendment"
          >
            <div className="admindash__documents_sbitemlft">Amendment</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/notice"
          >
            <div className="admindash__documents_sbitemlft">Notice</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/notice-resolved"
          >
            <div className="admindash__documents_sbitemlft">
              Notice Resolved
            </div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `${
                isActive
                  ? "admindash__documents_sbitemactive"
                  : "admindash__documents_sbitem"
              }`
            }
            to="/admin-dashboard/documents/itin"
          >
            <div className="admindash__documents_sbitemlft">ITIN</div>
            <div className="admindash__documents_sbitemsrt">(10)</div>
          </NavLink>
        </div>
      </div>
      <div className="admindash__documents_main">
        <Outlet />
      </div>
    </div>
  );
};

export default Documents;
